import React from "react";
import { format, formatDate, isDate, isValid } from "date-fns"
import { InputFieldProps } from "../../../models/Interfaces";
import Field from "./Field";
import { UTCDate } from "@date-fns/utc";
import { Theme } from "../../../misc/Theme";


interface OpenDateCheckbox {
    value: string;
    label: string;
}


interface DateFieldProps extends InputFieldProps {
    value?: string | Date;
    // initialValue?: string | Date;
    minDate?: string | Date;
    maxDate?: string | Date;
    openDateCheckbox?: OpenDateCheckbox;
    hideOpener?: boolean;
    native?: boolean
}


export default function DateField ({
    name = "",
    value = null,
    // initialValue = null,
    label = "",
    onChange,
    warning = "",
    helpText = "",
    formik = false,
    disabled = false,
    autoFocus = false,
    hideOpener = true,
    style = {},
    minDate = "1800-01-01",
    maxDate = "3000-01-01",
    openDateCheckbox = undefined,
}: DateFieldProps) {

    const [secondaryCheckbox, setSecondaryCheckbox] = React.useState(!!openDateCheckbox?.value)
    const [revertValue, setRevertValue] = React.useState(null)

    if (typeof minDate === "string") {
        minDate = new UTCDate(minDate)
    }

    if (typeof maxDate === "string") {
        maxDate = new UTCDate(maxDate)
    }

    // Turn any value into ISO date string
    if (typeof value === "string" && value.includes("T")) {
        value = value.split("T")[0]
    } else if (isDate(value) && isValid(value)) {
        value = format(new UTCDate(value), "yyyy-MM-dd")
    } else {
        value = value
    }

    var defaultValue: string = null
    
    if (value) {
        // console.log(value)
        value = new UTCDate(value)

        if (isValid(value)) {
            var defaultValue = formatDate(value, "yyyy-MM-dd")
        }
    }

    var color = "unset"
    if (!isValid(value)) {
        color = Theme.palette.error.main
    } else if (minDate && value < new Date(minDate)) {
        color = Theme.palette.error.main
    } else if (maxDate && value > new Date(maxDate)) {
        color = Theme.palette.error.main
    }

    return (
        <div className="form-field field-date" style={style}>
            <div style={{display: "flex", alignItems: "end"}}>
                <div className="field-date-native">
                    {label ? <label>{label}</label> : null}
                    
                    <input
                        type="date"
                        name="date"
                        defaultValue={defaultValue}
                        required={false}
                        style={{color: color}}
                        disabled={secondaryCheckbox || disabled}
                        autoFocus={autoFocus}
                        min={isDate(minDate) && isValid(minDate) ? format(new UTCDate(minDate), "yyyy-MM-dd"): null}
                        max={isDate(maxDate) && isValid(maxDate) ? format(new UTCDate(maxDate), "yyyy-MM-dd"): null}
                        onChange={(e) => onChange(e)} />
                </div>
                
                {openDateCheckbox ? (

                    // Secondary checkboxes are for when the value does not yet exist e.g. the person hasn't died yet.
                    // When checked it should set the value to secondaryCheckboxValues[0] and then disabled the 
                    // primary input. When unchecked it should revert to the value of the primary input.

                    <Field.Checkbox
                        formik
                        name="asdf"
                        label={openDateCheckbox.label}
                        value={secondaryCheckbox}
                        warning={false}
                        onChange={(e) => {
                            
                            var event = { target: {
                                name: name, 
                                value: openDateCheckbox.value
                            }}
                            
                            if (e.target.checked) {
                                setRevertValue(value)
                                setSecondaryCheckbox(true)
                            } else {
                                setSecondaryCheckbox(false)
                                event.target.value = revertValue ? format(new UTCDate(revertValue), "yyyy-MM-dd") : null
                            }
                            
                            onChange(event)
                        }} /> 

                ) : null}
                
            </div>

            {warning !== false && typeof warning === "string" ? <span className="warning">{warning}</span> : null}

            {helpText ? <span className="help-text">{helpText}</span> : null}

        </div>
    )
}